module.exports = __webpack_public_path__ + "img/scatterimg.db741699.svg";